import React from 'react'
import PropTypes from 'prop-types'
import ScrollSection from '../ScrollSection'
import Container from '../Container'
import Grid from '../Grid'
import GridItem from '../GridItem'
import Spacer from '../Spacer'
import { TextWrapper, TextContent } from './index.style'
import RichText from '../RichText'

const TextSection = ({ id, heading, text, linkId }) => {
  return (
    <ScrollSection>
      <TextWrapper id={linkId && linkId}>
        <Container>
          <Grid>
            <GridItem
              tabletP={8}
              tabletPStart={2}
              tabletL={4}
              tabletLStart={2}
              desk={3}
              deskStart={3}
            >
              <RichText id={`${id}-heading`} content={heading} />
            </GridItem>
            <GridItem
              tabletP={8}
              tabletPStart={2}
              tabletL={5}
              tabletLStart={6}
              desk={4}
              deskStart={7}
            >
              <TextContent>
                <RichText id={`${id}-text`} content={text} />
              </TextContent>
            </GridItem>
          </Grid>
          <Spacer size={[160, 286]} />
        </Container>
      </TextWrapper>
    </ScrollSection>
  )
}

TextSection.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.object,
  text: PropTypes.object,
}

export default TextSection
